const topics = [
  { label: '院线大片', hot: true },
  { label: '国产剧集', hot: true },
  { label: '韩剧热播', hot: true },
  { label: '美剧精选', hot: false },
  { label: '日剧推荐', hot: false },
  { label: '综艺娱乐', hot: true },
  { label: '纪录片', hot: false },
  { label: '动画动漫', hot: false },
  { label: '港剧经典', hot: false },
  { label: '泰剧专区', hot: false },
  { label: '短剧合集', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            当下最受关注的影视话题，帮你发现好内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                  : 'bg-background-100 text-foreground-500 hover:text-foreground-300 hover:bg-background-200 border border-background-200'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-primary-500 text-xs"></i>
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}